var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import Button from "@irati/ui/src/Button";
var MockButton = styled(Button).attrs({ primary: true })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 150px;\n  cursor: initial;\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  min-width: 150px;\n  cursor: initial;\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary1;
});
var MockButtonText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 15px;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.2);\n  height: 15px;\n  align-self: center;\n"], ["\n  border-radius: 15px;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.2);\n  height: 15px;\n  align-self: center;\n"])));
var PlaceholderButton = /** @class */ (function (_super) {
    __extends(PlaceholderButton, _super);
    function PlaceholderButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlaceholderButton.prototype.render = function () {
        return (React.createElement(MockButton, { margin: "15px 0" },
            React.createElement(MockButtonText, null)));
    };
    return PlaceholderButton;
}(PureComponent));
export default PlaceholderButton;
var templateObject_1, templateObject_2;
